module.exports = __webpack_public_path__ + "img/product_64.a26ac84.webp";